import { SaveCommonCriteria } from './SaveCommonCriteria';

/**
 * mutations
 *
 * @type {{SaveCommonCriteria: ((function({}=): Promise<*>)|*)}}
 */
export const mutations = {
  SaveCommonCriteria,
};
